"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Context = React.createContext(null);
exports.GlobalProvider = Context.Provider;
exports.GlobalConsumer = Context.Consumer;
//export const Provider = () => { return 'provider' }
//export const Consumer = () => { return 'consumer' }
//# sourceMappingURL=GlobalContext.js.map